/*
  周扬
  2023.06.15
  制作VPN申请页面
*/ 
<template>
  <div class="PartsVpn mainWrap"><!--需要修添加class-->
    <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);">
      <!-- 左边导航栏 -->
      <el-aside style="width:auto;">
        <leftNav msg="/VPN003"></leftNav><!--改组件名-->
      </el-aside>
      <!-- 右侧主体部分 -->
      <el-container>
        <!-- 页面部分 -->
        <el-scrollbar class="machineWrap" style="height:100%;width:100%;">
          <a download=""></a>
          <el-main>
            <!-- 添加盒子页面 -->
            <el-dialog :title="$t('VpnManage.boxMsg')" :visible.sync="addFormVisible">
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <!-- 所属工厂设备 -->
                <el-form-item :label="$t('VpnManage.belongMachine')" prop="machine">
                  <el-cascader
                  ref="cascader"
                  v-model="ruleForm.machine"
                  :options="options"
                  @change="handleChange"></el-cascader>
                </el-form-item>
                <!-- 盒子名称 -->
                <el-form-item :label="$t('VpnManage.boxName')" prop="boxName">
                  <el-input v-model="ruleForm.boxName"></el-input>
                </el-form-item>
                <!-- 有效日期 -->
                <el-form-item :label="$t('VpnManage.certificateLimitDate')" prop="certificateLimitDate">
                  <el-input v-model="ruleForm.certificateLimitDate"></el-input>
                </el-form-item>
                <!-- 提醒日期 -->
                <el-form-item :label="$t('VpnManage.notifyLimitDate')" prop="notifyLimitDate">
                  <el-input v-model="ruleForm.notifyLimitDate"></el-input>
                </el-form-item>
                <!-- 申请最多人数 -->
                <el-form-item :label="$t('VpnManage.certificateLimitNum')" prop="certificateLimitNum">
                  <el-input v-model="ruleForm.certificateLimitNum"></el-input>
                </el-form-item>
                <!-- 盒子类型 -->
                <el-form-item :label="$t('VpnManage.boxType')" prop="boxType">
                  <el-input v-model="ruleForm.boxType"></el-input>
                </el-form-item>
                <!-- 操作按钮 -->
                <el-form-item>
                  <el-button type="primary" @click="submitForm('ruleForm')">{{ $t('VpnManage.add') }}</el-button>
                  <el-button @click="closeForm('ruleForm')">{{ $t('VpnManage.cancel') }}</el-button>
                  <el-button @click="resetForm('ruleForm')">{{ $t('VpnManage.reset') }}</el-button>
                </el-form-item>
              </el-form>
            </el-dialog>
            <!-- 证书详情页面 -->
            <el-dialog :title="$t('VpnManage.certificateMsg')" :visible.sync="certificateVisible">
              <el-table
                :data="certificateData"
                stripe
                style="width: 100%">
                <!-- 申请人 -->
                <el-table-column
                  prop="applicantName"
                  :label="$t('VpnManage.applicant')">
                  <template slot-scope="scope">
                    <span>{{scope.row.applicantName}}</span>
                  </template>
                </el-table-column>
                <!-- 申请时间 -->
                <el-table-column
                  prop="applyTime"
                  :label="$t('VpnManage.applyTime')"
                  width="100px">
                  <template slot-scope="scope">
                    <span>{{formatDate(scope.row.applyTime)}}</span>
                  </template>
                </el-table-column>
                <!-- 分配ip地址 -->
                <el-table-column
                  prop="applicantIp"
                  :label="$t('VpnManage.applyIp')">
                  <template slot-scope="scope">
                    <span>{{scope.row.applicantIp}}</span>
                  </template>
                </el-table-column>
                <!-- 审核人 -->
                <el-table-column
                  prop="reviewerName"
                  :label="$t('VpnManage.reviewer')">
                  <template slot-scope="scope">
                    <span>{{scope.row.reviewerName}}</span>
                  </template>
                </el-table-column>
                <!-- 审核日期 -->
                <el-table-column
                  prop="reviewTime"
                  :label="$t('VpnManage.reviewTime')"
                  width="100px">
                  <template slot-scope="scope">
                    <span>{{formatDate(scope.row.reviewTime)}}</span>
                  </template>
                </el-table-column>
                <!-- 过期日期 -->
                <el-table-column
                  prop="reviewTime"
                  :label="$t('VpnManage.loseTime')"
                  width="100px">
                  <template slot-scope="scope">
                    <span>{{formatDate(scope.row.loseEfficacyTime)}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-dialog>

            <div class="mainWrao" v-loading="fullscreenLoading">
              <div class="recordTitle">
                <h1>{{$t('VpnManage.title')}}</h1>
              </div>
              <!-- 页面主体部分-->
              <div class="my">
              <!-- 我的 -->
                <div class="tableWrap">
                    
                    <div class="datePick">
                        <el-row>
                          <!-- 搜索公司名称 -->
                          <label class="code-margin">{{$t('VpnManage.searchCompany')}}：</label>
                          <el-input
                            class="code-select-width"
                            :placeholder="$t('VpnManage.enterCompany')"
                            v-model="companyContent"
                            clearable>
                          </el-input>
                          <!-- 搜索盒子名称 -->
                          <label class="code-margin">{{$t('VpnManage.searchBox')}}：</label>
                          <el-input
                            class="code-select-width"
                            :placeholder="$t('VpnManage.enterBox')"
                            v-model="boxContent"
                            clearable>
                          </el-input>
                          <!-- 三个按钮 -->
                          <div class="btns">
                              <el-button size="small" @click="btn_clean()">{{$t('VpnManage.Clean')}}</el-button>
                              <el-button style="margin-right: 30px;" type="primary" size="small" icon="el-icon-search" @click="searchDataByButton()">{{$t('VpnManage.search')}}</el-button>
                              <el-button type="primary" size="small" icon="el-icon-plus" @click="addDataByButton()"></el-button>
                          </div>
                        </el-row>
                    </div>

                    <!-- 表格 -->
                    <el-table
                      v-loading="loading"
                      :data="tableData"
                      style="width: 100%; text-align: center;"
                      :empty-text="$t('WorkShopDashBoard.noEquipmentTableMessage')">
                      <!-- 公司名称 -->
                      <el-table-column
                          prop="machineEn"
                          :label="$t('VpnManage.company')"
                          max-width="200">
                          <template slot-scope="scope">
                            <span>{{scope.row.factoryName}}</span>
                          </template>
                      </el-table-column>
                      <!-- 盒子名称 -->
                      <el-table-column
                          prop="msgEn"
                          :label="$t('VpnManage.boxName')"
                          max-width="200">
                          <template slot-scope="scope">
                            <span>{{scope.row.boxName}}</span>
                          </template>
                      </el-table-column>
                      <!-- 盒子类型 -->
                      <el-table-column
                          prop="msgEn"
                          :label="$t('VpnManage.boxType')"
                          max-width="200">
                          <template slot-scope="scope">
                            <span>{{scope.row.boxType}}</span>
                          </template>
                      </el-table-column>
                      <!-- 盒子IP -->
                      <el-table-column
                          prop="msgEn"
                          :label="$t('VpnManage.boxIP')"
                          max-width="200">
                          <template slot-scope="scope">
                            <span>{{scope.row.boxIp}}</span>
                          </template>
                      </el-table-column>
                      <!-- 创建者 -->
                      <el-table-column
                          prop="msgEn"
                          :label="$t('VpnManage.createUser')"
                          max-width="200">
                          <template slot-scope="scope">
                            <span>{{scope.row.createrName}}</span>
                          </template>
                      </el-table-column>
                      <!-- 创建时间 -->
                      <el-table-column
                          prop="typeEn"
                          :label="$t('VpnManage.createTime')"
                          width="100px">
                          <template slot-scope="scope">
                            <span>{{formatDate(scope.row.createTime)}}</span>
                          </template>
                      </el-table-column>
                      <!-- 证书数量 -->
                      <el-table-column
                          prop="endStateDesEn"
                          :label="$t('VpnManage.credentials')"
                          max-width="200">
                          <template slot-scope="scope">
                            <el-button type="text" @click="handleCertificate(scope.row.boxApplyFormList)">{{scope.row.total}}</el-button>
                          </template>
                      </el-table-column>
                      <!-- 删除按钮 -->
                      <el-table-column
                          prop="endStateDesEn"
                          :label="$t('VpnManage.operation')"
                          max-width="200">
                          <template slot-scope="scope">
                            <el-button style="color: red;" type="text" @click="handleDelete(scope.row)">{{ $t('VpnManage.operationDelete') }}</el-button>
                          </template>
                      </el-table-column>
                    </el-table>
                </div>
                <!-- 分页 -->
                <el-pagination
                    class="pagination"
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :current-page.sync="nowPage"
                    @current-change="handleCurrentChange"
                    @size-change="handleCurrentSizeChange">
                </el-pagination>
              </div>
            </div>
          </el-main>
        </el-scrollbar>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import leftNav from "@/components/nav.vue"
import { formatDate } from '../assets/js/date.js'

export default {
  name: 'VPN001',
  components: {
    leftNav
  },
  data () {
    return {
      // 全局加载控制
      fullscreenLoading: false,
      // 表格加载提示开关
      loading: false,
      // 当前页数
      nowPage: 1,
      // 每页数量
      nowPageSize: 10,
      // 总页数
      total: 1,
      // 模糊搜索-公司名称
      companyContent:'',
      // 模糊搜索-盒子名称
      boxContent:'',
      // 表格数据
      tableData: [],
      // 添加信息弹出框
      addFormVisible: false,
      value: [],
      // 工厂-机器列表信息
      options: [],
      // 添加盒子信息
      ruleForm: {
        boxName: '',
        machine: '',
        machineId: 0,
        tenantCode: '',
        boxType: '',
        certificateLimitNum: 3,
        certificateLimitDate: 7,
        notifyLimitDate: 2
      },
      // 添加盒子校验规则
      rules: {
        boxName: [
          { required: true, message: this.$t('VpnManage.enterBoxName'), trigger: 'blur' }
        ],
        machine: [
          { required: true, message: this.$t('VpnManage.chooseMachine'), trigger: 'change' }
        ],
        boxType: [
        { required: false, message: this.$t('VpnManage.enterBoxType'), trigger: 'blur' }
        ]
        ,
        certificateLimitNum: [
        { required: true, message: this.$t('VpnManage.enterCertificateLimitNum'), trigger: 'blur' }
        ]
        ,
        certificateLimitDate: [
        { required: true, message: this.$t('VpnManage.enterCertificateLimitDate'), trigger: 'blur' }
        ]
        ,
        notifyLimitDate: [
        { required: true, message: this.$t('VpnManage.enterNotifyLimitDate'), trigger: 'blur' }
        ]
      },
      // 证书页面是否显示
      certificateVisible: false,
      // 证书详情页
      certificateData: []
    }
  },
  computed: {
    islangChange () {
      return this.$store.state.lang
    }
  },
  watch: {
    datevalue(){

    }
  },
  created(){
    this.searchData()
  },
  mounted() {
  
  },
  destroyed() {
  },
  methods: {
    // 页码变化
    handleCurrentChange (val) {
      this.nowPage = val
      this.searchData()
    },
    // 每页条数变化
    handleCurrentSizeChange (val) {
      this.nowPageSize = val
      this.searchData()
    },
    // 通过点击查询按钮查询数据
    searchDataByButton () {
      this.nowPage = 1
      this.searchData()
    },
    // 查询工厂-设备数据
    searchFactoryData () {
      this.loading = true
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/box/factoryList',
      }).then(function(res){
        _this.loading = false
        if (res.data.success === 'false') {
          _this.$message.error(res.data.msg);
        }else{
          _this.options = res.data.list
        }
      }).catch(function () {
          _this.loading = false
      })
    },
    // 查询数据
    searchData () {
      this.loading = true
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/box/boxMsgList',
        params:{
          pageNum: _this.nowPage,
          pageSize: _this.nowPageSize,
          boxName: _this.boxContent, //盒子关键字
          factoryName: _this.companyContent //公司关键字
        }
      }).then(function(res){
        _this.loading = false
        if (res.data.success === 'false') {
          _this.$message.error(res.data.msg);
        }else{
          _this.total = res.data.total //页码数
          _this.tableData = res.data.list
        }
      }).catch(function () {
          _this.loading = false
      })
    },
    // 清除功能
    btn_clean () {
      // 当前页数
      this.nowPage =  1
      this.nowPageSize =  10

      // 输入查询的内容
      this.companyContent = '';
      this.boxContent=''

    },
    // 添加盒子
    addDataByButton () {
      this.addFormVisible = true
      this.searchFactoryData()
    },
    // 添加盒子-设备选择
    handleChange (value) {
      let nodesInfo = this.$refs['cascader'].getCheckedNodes()
      this.ruleForm.boxName = nodesInfo[0].data.label
      this.ruleForm.tenantCode = value[0]
      this.ruleForm.machineId = value[1]
    },
    // 删除盒子
    handleDelete (box) {
      let _this = this
      this.$confirm('您确定要删除“' + box.boxName + '”吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 确定删除
        _this.deleteBoxmsg(box.id)
      }).catch(() => {
        // 取消        
      });
    },
    // 申请证书详情
    handleCertificate (list) {
      this.certificateData = list
      this.certificateVisible = true
    },
    // 添加-保存操作
    submitForm(formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.doAdd()
        } else {
          return false;
        }
      });
    },
    // 添加-重置操作
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm.machine = ''
    },
    // 添加-关闭操作
    closeForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm.machine = ''
      this.addFormVisible = false;
    },
    // 添加-调用接口
    doAdd() {
      this.fullscreenLoading = true
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/box/addBoxMsg',
        params:{
          userId: _this.$store.state.authCode, //用户id
          tenantCode: _this.ruleForm.tenantCode, //工厂code
          machineId: _this.ruleForm.machineId, //操作人id
          boxName: _this.ruleForm.boxName, //盒子名称
          certificateLimitNum: _this.ruleForm.certificateLimitNum, //证书上限
          certificateLimitDate: _this.ruleForm.certificateLimitDate, //有效天数
          notifyLimitDate: _this.ruleForm.notifyLimitDate, //通知天数
          boxType: _this.ruleForm.boxType // 盒子类型
        }
      }).then(function(res){
        
        _this.closeForm('ruleForm')
        _this.searchData()
        _this.fullscreenLoading = false
          
      }).catch(function () {
        _this.fullscreenLoading = false
      })
    },
    // 删除-调用接口
    deleteBoxmsg(id) {
      this.fullscreenLoading = true
      let _this = this
      this.axios({
        method: 'delete',
        url: '/url/box/deleteBoxMsg',
        params:{
          boxId: id //盒子id
        }
      }).then(function(res){
        _this.fullscreenLoading = false

        if (res.data.success === 'false') {
          _this.$message.error(res.data.msg);
        }else{
          _this.checkPage()
          _this.searchData()
        }
          
      }).catch(function () {
        _this.fullscreenLoading = false
      })
    },
    // 时间格式化
    formatDate (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    },
    checkPage () {
      let totals = this.total-1
      let pageNums = this.nowPage-1
      let allPageSize = pageNums*(this.nowPageSize)
      if (totals<=allPageSize) {
        if ((this.nowPage-1)>0) {
          this.nowPage = this.nowPage-1
        } else{
          this.nowPage = 1
        }
      }
    }
    
  }
}
</script>

<style scoped>
.PartsVpn{
   min-width: 1365px!important;/*最小宽度 */
}
.mainWrao{
  height: 100%;
  width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
  padding-bottom: 35px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
}
.recordTitle h1{
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
  display: inline-block;
}

/* 我的样式 */
.recordTitle div a {
  margin-left: 20px;
  color: #6bb4df;
}

.tableWrap{
  padding: 5px 30px;
}

.datePick{
  margin: 10px 0;
}
.datePick .btns{
  float: right;
}

.pagination{
  text-align: center;
  margin-top: 35px;
}

.type-select-width{
    width: 170px;
}
.code-select-width{
    width: 144px;
}
.code-margin{
    margin-left: 10px;
}

</style>

